import React, { useMemo } from 'react';
import SourceIcon from "@components/sources/SourceIcon.component";
import { Analysis } from '@models/analysis';

interface AnalysisSourcesProps {
  analysis: Analysis;
  label?: string;
  className?: string;
}

const AnalysisSources: React.FC<AnalysisSourcesProps> = ({
  analysis,
  label = "This data comes from",
  className = ""
}) => {
  const sourceIds = useMemo(() => {
    if (analysis.uses_source_ids && analysis.uses_source_ids.length > 0) {
      return analysis.uses_source_ids;
    }
    return [];
  }, [analysis.uses_source_ids]);

  if (!sourceIds.length) {
    return null;
  }

  return (
    <div className={`d-flex flex-wrap align-items-center gap-2 ${className}`}>
      <span className="d-none d-sm-inline" style={{ fontSize: '13px', lineHeight: 1, color: '#5a6570' }}>{label}</span>
      <div className="d-flex flex-wrap align-items-center gap-1">
        {sourceIds.map((sourceId, index) => (
          <span 
            key={index}
            className="d-inline-flex align-items-center px-2 py-1 rounded-pill"
            style={{ 
              backgroundColor: 'white',
              border: '1px solid #dee2e6',
              fontSize: '12px',
              lineHeight: 1
            }}
          >
            <SourceIcon 
              sourceId={sourceId} 
              compact={true} 
              showTitle={true} 
            />
          </span>
        ))}
      </div>
    </div>
  );
};

export default AnalysisSources;